/** Enum for space.one converter states. */
export enum ConverterState {
  Uploading = 'UPLOADING',
  Waiting = 'WAITING',
  Converting = 'CONVERTING',
  Ready = 'READY',
  Failed = 'FAILED'
}
